export const countryCodeMapping = {
  belgien: 'BE',
  bulgarien: 'BG',
  daenemark: 'DK',
  deutschland: 'DE',
  england: 'GB',
  finnland: 'FI',
  frankreich: 'FR',
  griechenland: 'GR',
  italien: 'IT',
  kroatien: 'HR',
  lettland: 'LV',
  luxemburg: 'LU',
  niederlande: 'NL',
  norwegen: 'NO',
  oestereich: 'AT',
  polen: 'PL',
  portugal: 'PT',
  rumaenien: 'RO',
  russland: 'RU',
  schweden: 'SE',
  schweiz: 'CH',
  slowakei: 'SK',
  slowenien: 'SI',
  spanien: 'ES',
  tschechien: 'CZ',
  ungarn: 'HU'
};
